<template>
  <section class="view-wrap">
    <div class="header-spacer"></div>
    <div class="container">
      <div class="row row-wrap">
        <div class="column column-100">
          <h1>{{ info.title }}</h1>
        </div>
        <div class="column column-100" v-if="info.content">
          <div v-if="info.hero_image">
            <transition name="fade">
              <img :src="info.hero_image.url" @load="imageLoaded=true" v-show="imageLoaded" />
            </transition>
          </div>

          <!-- STREAMFIELD -->
          <div v-for="block in info.content" v-bind:key="block.id">
            <div v-html="block.value"></div>
          </div>
          <!-- END STREAMFIELD -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import TopMenu from '@/components/TopMenu.vue'
import axios from "axios";
import NodeInfo from "@/components/NodeInfo.vue";
import RelatedItems from "@/components/RelatedItems.vue";
import BasicMap from "@/components/BasicMap.vue";
export default {
  name: "promotionalpage",
  data() {
    return {
      info: [],
      imageLoaded: false,
    };
  },
  components: {
    NodeInfo,
    RelatedItems,
    BasicMap,
  },
  props: {
    backPageID: null,
  },
  watch: {
    $route(to, from) {
      this.fetchData().then((data) => {
        this.info = data;
      });
    },
  },
  created() {
    this.fetchData().then((data) => {
      this.info = data;
      if (this.info.custom_styles) {
        let styles = document.createElement("style");
        styles.type = "text/css";
        styles.id = "temp-styles";
        for (let d in this.info.custom_styles) {
          if (!this.info.custom_styles[d].value.hide) {
            styles.appendChild(
              document.createTextNode(this.info.custom_styles[d].value.style)
            );
          }
        }
        document.getElementsByTagName("head")[0].appendChild(styles);
      }
    });
    if (this.backPageID) {
      document.body.classList.add("body-slide-open");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.info.custom_styles) {
      let tempSty = document.getElementById("temp-styles");
      if (tempSty) {
        tempSty.remove();
      }
    }
    document.body.classList.remove("body-slide-open");
    next();
  },
  mounted() {
    //  console.log('MOUNTED PAGE')
  },
  updated() {
    // console.log('UPDATED PAGE')
    // console.log(this.info)
  },
  methods: {
    fetchData() {
      console.log("FETCH THE DATA");
      var id = this.$route.meta.id;
      return axios.get("/api/v2/pages/" + id).then((response) => {
        //  console.log(JSON.stringify(response))
        return response.data;
      });
    },
  },
};
</script>


<style scoped>
.header-spacer {
  height: 75px;
  background: #333;
}
.slide-section h1 {
  font-size: 3.6rem;
}

.right-side {
  position: relative;
}

.close-window {
  /* cursor: pointer; */
  text-align: right;
  display: flex;
  align-items: center;
  position: absolute;
  top: -5.85rem;
  right: 1rem;
}

.close-window:hover {
  color: #ccc;
}

.close-window i {
  display: inline-block;
  cursor: pointer;
}

.close-window h4 {
  display: inline-block;
  cursor: pointer;
  margin-right: 1rem;
  margin-bottom: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */

.fade-enter-active {
  transition: all 1s ease;
}
.fade-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all 1s ease;
}
.fade-enter, .fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  /* transform: translateX(100%); */
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all 0.5s ease;
}
.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-enter-active {
  transition: all 0.5s ease;
}
.slide-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all 0.5s ease;
}
.slide-enter, .slide-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  /* opacity: 0; */
}
</style>
